// Imports
import React, { useEffect, useState,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDispositionList } from '../features/dispositionSlice'; 
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import Navbar from './Navbar';
import axios from 'axios';

import { triggerToast } from '../utils/toast';

import { setValue, getToken, getValue } from '../utils/auth';


const base_url = process.env.REACT_APP_API_BASE_URL;

const DispositionList = () => {
  const dispatch = useDispatch();
  const isFetcingUser = useRef( false );
  const [selectedDisposition, setSelectedDisposition] = useState([]);
  const dispositionList = useSelector((state) => state.dispositionList.dispositionList);
  const dispositionStatus = useSelector((state) => state.dispositionList.status);
  const adminSettings = useSelector((state) => state.setting.adminSettings);
 
  // Fetch admin settings
  useEffect(() => {
    
  }, [dispatch]);

  // Fetch disposition list
  useEffect(() => {
   
    if ( !isFetcingUser.current ) {
      dispatch(fetchDispositionList());
      isFetcingUser.current = true
    }
  }, [dispatch, dispositionStatus]);

   // Update selected dispositions
  useEffect(() => {
    (dispositionList || []).forEach((obj, index) =>{
      if(obj.isactive){
        
        selectedDisposition.push(obj.id);        
        
      }else {
        
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispositionList]);

  


   // Handle form submission
  const handleSubmit = async(e) =>{
    e.preventDefault();
    try{
      
      const activeDispositions = [];
      // eslint-disable-next-line no-lone-blocks
      {(selectedDisposition || []).map((id, index) => (
        activeDispositions.push(id)
        
      ))};
      
      const requestBody = JSON.parse('{"ids":['+activeDispositions+'],"activeStatus":true}');
      
      const response = await axios.post(`${base_url}/api/visits/updateDispositionActiveStatus`, requestBody, {
      headers: { 
        Authorization: `Bearer ${getToken()}`,
      }});

      
    
      dispatch(fetchDispositionList());
      
      triggerToast(response.data.message, 'success');
       
    
    } catch (error) {
      triggerToast(error.message, 'error');
      
    }
  }
      
      setValue('headingFontSize', adminSettings?.properties?.headingFontSize);
      setValue('subHeadingFontSize', adminSettings?.properties?.subHeadingFontSize);



        const hdngFontSize = getValue('headingFontSize');
        const subHdngFontSize = getValue('subHeadingFontSize')
        

  // Handle selection of dispositions
  const selectList = (e, dispId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      
      setSelectedDisposition([...selectedDisposition, dispId]);
    } else {
      setSelectedDisposition(selectedDisposition.filter(id => id !== dispId));
    }
   
  };

  return (
    <div className="home-container d-flex flex-column flex-lg-row">
      <Navbar />
      <main className="content flex-grow-1">
        <h3 className="mb-3" style={{fontSize: hdngFontSize + "px"}}>Disposition List</h3>
        <Container className="bg-white rounded-2" style={{ padding: '20px', justifyContent: 'center'  }}>
          <Form onSubmit={handleSubmit}>
            <Row className="align-items-center mb-3" style={{ display: 'flex', justifyContent: 'center' }}>
            
              <Col sm={6}>
              <h6 style={{fontSize: subHdngFontSize + "px"}}>List of Disposition Items</h6>
              <p>Please choose to activate or deactivate.</p>
              {(dispositionList || []).map((dispositionList, index) => (
                  <Form.Check 
                    key={dispositionList.id}
                    type="checkbox"
                    
                    defaultChecked={dispositionList.isactive}
                    onChange={(e) => selectList(e, dispositionList.id)}
                    label={dispositionList.disposition}
                  />
                ))}
                
            <Button
                variant="primary"
                type="submit"
                style={{  marginTop: '30px', backgroundColor: adminSettings?.properties?.primaryButtonColor }}
                className="text-center "
              
              >Submit</Button>
            </Col>
            </Row>
          </Form>

      
        </Container>
      </main>
    </div>
  );
};

export default DispositionList;
